<section
  class="grouping"
  [formGroup]="groupForm"
  *ngIf="
    currentDataFields &&
    currentDataFields.length > 0 &&
    chartType &&
    chartType != 'Table' &&
    chartType != 'List'
  "
>
  <span
    class="addGroup"
    *ngIf="currentDataFields && currentDataFields.length > 0"
    >GROUP BY FIELD*
  </span>

  <div class="fieldArea" [formGroup]="groupForm">
    <div class="group-list">
      <div>
        <div class="reportField-box">
          <div class="canvasFields">
            <div class="right">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-select
                  formControlName="fields"
                  placeholder="Choose Grouping"
                  floatPlaceholder="never"
                  id="groupSelect"
                >
                  <mat-option
                    *ngFor="let item of currentDataFields"
                    [value]="item.id"
                    (click)="
                      selectSubGrouping(item.type, item.name, item.id);
                      buildAggregateData(item.id)
                    "
                  >
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="groupingRange" *ngIf="showGrouping">
            <form [formGroup]="editForm" class="form" (change)="applyChange()">
              <label>
                <input type="radio" value="D" formControlName="range" />
                <span>Day</span>
              </label>
              <label>
                <input type="radio" value="M" formControlName="range" />
                <span>Month</span>
              </label>
              <label>
                <input type="radio" value="Q" formControlName="range" />
                <span>Quarter</span>
              </label>
              <label>
                <input type="radio" value="Y" formControlName="range" />
                <span>Year</span>
              </label>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
